































import Component from 'vue-class-component';
import { IDictionary } from '@/entities/dictionary.interface';
import { IFormControl } from '@/entities/form.interface';
import { EditPage } from '@/components/base/edit/edit-page';
import * as ent from '@/entities';
import sitesManualsApi from '@/api/site-manuals.api';

const passwordDefaultValidator = 'confirmed:passwordConfirm'; // TODO move to entities valid-rules.ts

@Component({})
export default class SiteManualsEdit extends EditPage {
    public parentPath: string = '/app/site-manuals';

    public availableSites: ent.IListItem[] = [];

    public formState: IDictionary<IFormControl> = {
        siteId: {
            key: 'siteId',
            label: `Site`,
            value: '',
            validators: 'required'
        },
        sitename: {
            key: 'sitename',
            label: `Site`,
            value: ''
        },
        title: {
            key: 'title',
            label: `Display title`,
            value: '',
            validators: 'required'
        },
        html: {
            key: 'html',
            label: 'Html',
            value: '',
            validators: 'required'
        }
    };

    public async created() {
        await super.created();
        await this._loadSites();
    }

    get selectedSitename() {
        const siteId = this.formState.siteId.value;
        if (!siteId) {
            return;
        }
        const site = this.availableSites.find((x) => x.value === siteId);
        return site ? site.heading : '';
    }

    public siteChange() {
        this.formState.title.value = this.selectedSitename;
    }

    // TODO own resourse service will be nice for api calls
    public detail(id: number): Promise<ent.ISiteManualDetailModel> {
        return sitesManualsApi.get(id);
    }

    public create(body: any): Promise<number> {
        return sitesManualsApi.create({ id: this.formState.siteId.value, ...body });
    }

    public update(body: any): Promise<number> {
        return sitesManualsApi.update(this.id, body);
    }

    private async _loadSites() {
        const sites = await sitesManualsApi.availableSites();
        this.availableSites = [
            { heading: 'Please select site', value: '' },
            ...sites
        ];
    }
}
